import styled from 'styled-components';

import { Button } from './Button';

export const MenuButton = styled(Button)`
  padding: 0;
  color: inherit;
  height: unset;
  transition: unset;
  &:hover,
  &:focus {
    color: inherit;
  }
`;
